var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoftware = function SvgSoftware(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#software_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13V3.25A1.5 1.5 0 0 1 5 1.75h15a1.5 1.5 0 0 1 1.5 1.5v6M10.5 13h-9a4.14 4.14 0 0 0 1.098 2.829A3.64 3.64 0 0 0 5.25 17H8.5M12.5 17.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.152 17.652H17.5V15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "software_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgSoftware;